import dayjs from 'dayjs';

export const IdleCallback = window.setTimeout;
export const forMatterTime = (date: string | number, time = false) => {
  return dayjs(date).format(`YYYY/MM/DD ${time ? 'HH:mm' : ''}`);
};

export function debounce<T extends (...args: any[]) => any>(fn: T, wait = 0) {
  if (!wait) {
    return fn;
  }

  let timer: any = null;

  return (...args: any[]) => {
    if (timer) {
      clearTimeout(timer);
    }
    // 保存查询之后输入值
    timer = setTimeout(function () {
      fn.apply(null, args);
    }, wait);
  };
}

export function suspendStr(str: string = '', startLength = 0, endLength = 0) {
  const strLen = str.length;
  if (!strLen || !startLength || startLength >= strLen || startLength + endLength >= strLen)
    return str;

  const start = str.substr(0, startLength);
  const end = endLength ? str.substr(-endLength) : '';

  return `${start}...${end}`;
}

export function safeJsonParse<T>(str = '', defaultValue: T): T {
  if (!str) return defaultValue;

  let result = defaultValue;
  try {
    result = JSON.parse(str);
  } catch (err) {
    console.log('safe json parse error', err);
  }

  return result;
}

export const subSetList = (setFn: any, list: any, intervalMs = 200, subLength = 30) => {
  const listLength = list.length;
  let timer: number | null = null;

  const clearTimer = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const resolveSub = (idx: number) =>
    new Promise<void>(resolve => {
      timer = window.setTimeout(() => {
        setFn(list.slice(0, idx + subLength));
        resolve();
      }, intervalMs);
    });

  const loopFn = (i: number) => {
    resolveSub(i).then(() => {
      if (i < listLength) {
        i += subLength;
        loopFn(i);
      }
    });
  };

  loopFn(0);

  return clearTimer;
};

export function sleep(ms = 0, signal?: AbortController['signal']) {
  if (signal?.aborted || ms < 0) {
    return Promise.reject(new DOMException('Aborted', 'AbortError'));
  }

  return new Promise<void>((resolve, reject) => {
    const abortHandler = () => {
      clearTimeout(timer);
      reject(new DOMException('Aborted', 'AbortError'));
      signal?.removeEventListener('abort', abortHandler);
    };

    signal?.addEventListener('abort', abortHandler);

    const timer = setTimeout(() => {
      resolve();

      signal?.removeEventListener('abort', abortHandler);
    }, ms);
  });
}

export const noop = () => {};
